package top.wcpe.allincore.ui.runtime.element

import top.wcpe.allincore.ui.runtime.theme.ControlTheme
import kotlin.jvm.JvmName
import kotlin.jvm.JvmStatic

/**
 * Text 排版角色，对应 DSL typography 的 15 个字符串值。
 */
enum class TextTypography(@get:JvmName("dslName") val dslName: String) {
    DISPLAY_LARGE("displayLarge") {
        override fun metrics(theme: ControlTheme) = TypographyMetrics(
            theme.typographyDisplayLargeSize,
            theme.typographyDisplayLargeLineHeight,
            theme.typographyDisplayLargeLetterSpacing,
        )
    },
    DISPLAY_MEDIUM("displayMedium") {
        override fun metrics(theme: ControlTheme) = TypographyMetrics(
            theme.typographyDisplayMediumSize,
            theme.typographyDisplayMediumLineHeight,
            theme.typographyDisplayMediumLetterSpacing,
        )
    },
    DISPLAY_SMALL("displaySmall") {
        override fun metrics(theme: ControlTheme) = TypographyMetrics(
            theme.typographyDisplaySmallSize,
            theme.typographyDisplaySmallLineHeight,
            theme.typographyDisplaySmallLetterSpacing,
        )
    },
    HEADLINE_LARGE("headlineLarge") {
        override fun metrics(theme: ControlTheme) = TypographyMetrics(
            theme.typographyHeadlineLargeSize,
            theme.typographyHeadlineLargeLineHeight,
            theme.typographyHeadlineLargeLetterSpacing,
        )
    },
    HEADLINE_MEDIUM("headlineMedium") {
        override fun metrics(theme: ControlTheme) = TypographyMetrics(
            theme.typographyHeadlineMediumSize,
            theme.typographyHeadlineMediumLineHeight,
            theme.typographyHeadlineMediumLetterSpacing,
        )
    },
    HEADLINE_SMALL("headlineSmall") {
        override fun metrics(theme: ControlTheme) = TypographyMetrics(
            theme.typographyHeadlineSmallSize,
            theme.typographyHeadlineSmallLineHeight,
            theme.typographyHeadlineSmallLetterSpacing,
        )
    },
    TITLE_LARGE("titleLarge") {
        override fun metrics(theme: ControlTheme) = TypographyMetrics(
            theme.typographyTitleLargeSize,
            theme.typographyTitleLargeLineHeight,
            theme.typographyTitleLargeLetterSpacing,
        )
    },
    TITLE_MEDIUM("titleMedium") {
        override fun metrics(theme: ControlTheme) = TypographyMetrics(
            theme.typographyTitleMediumSize,
            theme.typographyTitleMediumLineHeight,
            theme.typographyTitleMediumLetterSpacing,
        )
    },
    TITLE_SMALL("titleSmall") {
        override fun metrics(theme: ControlTheme) = TypographyMetrics(
            theme.typographyTitleSmallSize,
            theme.typographyTitleSmallLineHeight,
            theme.typographyTitleSmallLetterSpacing,
        )
    },
    BODY_LARGE("bodyLarge") {
        override fun metrics(theme: ControlTheme) = TypographyMetrics(
            theme.typographyBodyLargeSize,
            theme.typographyBodyLargeLineHeight,
            theme.typographyBodyLargeLetterSpacing,
        )
    },
    BODY_MEDIUM("bodyMedium") {
        override fun metrics(theme: ControlTheme) = TypographyMetrics(
            theme.typographyBodyMediumSize,
            theme.typographyBodyMediumLineHeight,
            theme.typographyBodyMediumLetterSpacing,
        )
    },
    BODY_SMALL("bodySmall") {
        override fun metrics(theme: ControlTheme) = TypographyMetrics(
            theme.typographyBodySmallSize,
            theme.typographyBodySmallLineHeight,
            theme.typographyBodySmallLetterSpacing,
        )
    },
    LABEL_LARGE("labelLarge") {
        override fun metrics(theme: ControlTheme) = TypographyMetrics(
            theme.typographyLabelLargeSize,
            theme.typographyLabelLargeLineHeight,
            theme.typographyLabelLargeLetterSpacing,
        )
    },
    LABEL_MEDIUM("labelMedium") {
        override fun metrics(theme: ControlTheme) = TypographyMetrics(
            theme.typographyLabelMediumSize,
            theme.typographyLabelMediumLineHeight,
            theme.typographyLabelMediumLetterSpacing,
        )
    },
    LABEL_SMALL("labelSmall") {
        override fun metrics(theme: ControlTheme) = TypographyMetrics(
            theme.typographyLabelSmallSize,
            theme.typographyLabelSmallLineHeight,
            theme.typographyLabelSmallLetterSpacing,
        )
    }, ;

    abstract fun metrics(theme: ControlTheme): TypographyMetrics

    /** 排版 token 度量值；letterSpacing 当前只透传为 token 能力，不由 RenderBridge 绘制。 */
    data class TypographyMetrics(
        @get:JvmName("size") val size: Float,
        @get:JvmName("lineHeight") val lineHeight: Float,
        @get:JvmName("letterSpacing") val letterSpacing: Float,
    )

    companion object {
        /** 解析 DSL 字符串，未知值返回 null，供调用方决定诊断或运行期兜底策略。 */
        @JvmStatic
        fun tryParse(value: String?): TextTypography? {
            val normalized = value?.trim() ?: return null
            return entries.firstOrNull { it.dslName == normalized }
        }

        /** 运行期兜底解析：未知值回退到 bodyMedium。 */
        @JvmStatic
        fun fromString(value: String?): TextTypography = tryParse(value) ?: BODY_MEDIUM
    }
}
